import { fetchQuery, graphql } from "relay-runtime"
import {
  deMagicWandQuery as deMagicWandQueryType,
  MagicWandInput,
} from "@/modules/chats/services/ai/de/__generated__/deMagicWandQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deMagicWandQuery($input: MagicWandInput!) {
    magicWand: de_magicWand(input: $input) {
      ...TextResultFragment @relay(mask: false)
    }
  }
`

export const deMagicWandQuery = (input: MagicWandInput) => {
  return fetchQuery<deMagicWandQueryType>(RelayEnvironment, query, { input }).toPromise()
}
